import { createGyymApiClient } from '@gyym/sdk'

export const gyymClient = createGyymApiClient({
  baseURL: process.env.NEXT_PUBLIC_API_HOST,
})
